import React from "react";
import { useNavigate } from "react-router-dom";
import { useSettings } from "./SettingsContext"; // Import the custom hook for accessing context
import vol from "../../assests/volume.png";
import call from "../../assests/phone-call.png";
import back from "../../assests/back-w.svg";

interface SettingProps {
  embedded?: boolean;
}

const Setting: React.FC<SettingProps> = ({ embedded = false }) => {
  const navigate = useNavigate();
  const { settings, toggleEnabled } = useSettings(); // Access settings and toggle function from context

  return (
    <>
      {!embedded && (
        <div className="bg-[#3E3E3E] h-[90px] w-full flex items-center justify-between px-3 ">
          <div className="flex gap-2 text-white font-outfit">
            <div onClick={() => navigate("/kitchen")}>
              <img src={back} alt="back" className="h-9 w-8" />
            </div>
            <h3>Settings</h3>
          </div>

          <div className="flex items-center gap-4">
            <div className="h-10 text-white flex items-center gap-3 justify-center">
              <img
                src={vol}
                alt="Notifications"
                className="w-[30px] h-[30px] bg-white rounded-full cursor-pointer"
                onClick={() => navigate("/kitchen/notification")}
              />
            </div>
          </div>
        </div>
      )}

      {/* Settings list */}
      <div className={embedded ? "p-4" : "p-6"}>
        <div className="space-y-4">
          {settings.map((cat, index) => (
            <div
              key={cat.name}
              className="flex items-center justify-between border-b border-gray-200 pb-2"
            >
              <span className="font-outfit text-gray-800">{cat.name}</span>

              <div className="flex items-center gap-6">
                {/* Toggle */}
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only"
                    checked={cat.enabled}
                    onChange={() => toggleEnabled(index)}
                  />
                  <div
                    className={`relative w-10 h-5 cursor-pointer rounded-full transition-all duration-100 ${
                      cat.enabled ? "bg-[#7CBF80]" : "bg-gray-300"
                    }`}
                  >
                    <div
                      className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white rounded-full transition-all duration-300 ${
                        cat.enabled ? "translate-x-1" : "-translate-x-3"
                      }`}
                    />
                  </div>
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Setting;
